// The Rouser wordmark + small logo mark. The mark renders an inline SVG
// rather than a bare CSS dot so the concentric rings stay visible at
// header sizes (18–22px). The outer ring runs a slow radar-ping
// animation — fades up briefly every ~2.4s — to suggest "always
// listening" without becoming distracting.

type Size = 'sm' | 'md' | 'lg';

export function Brand({ size = 'md' }: { size?: Size }) {
  const fontSize =
    size === 'sm' ? 'var(--fs-sm)' : size === 'lg' ? 'var(--fs-xl)' : 'var(--fs-md)';
  const markSize = size === 'sm' ? 16 : size === 'lg' ? 24 : 20;
  return (
    <span className="ds-brand" style={{ fontSize }}>
      <BrandMark size={markSize} />
      Rouser
    </span>
  );
}

function BrandMark({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      className="ds-brand__mark"
    >
      {/* Outer ring — pings on a 2.4s loop. */}
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="var(--color-accent)"
        strokeWidth="1"
        opacity="0.2"
        className="ds-brand__mark-ping"
      />
      {/* Middle ring — static, mid weight. */}
      <circle cx="12" cy="12" r="6" stroke="var(--color-accent)" strokeWidth="1" opacity="0.55" />
      {/* Solid centre dot. */}
      <circle cx="12" cy="12" r="2.75" fill="var(--color-accent)" />
    </svg>
  );
}
